/* eslint-disable */
import { useState, useEffect } from "react";
import { Form } from "react-final-form";
import BasicInvoiceDetailsForm from "./basicDetails";
import ProductDetails from "./productDetails";
import BankDetailsForm from "./bankDetails";
import FinalTotalForm from "../../invoice/components/finalTotal";
import useQuotationHook from "../useQuotation";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import alertify from "alertifyjs";

const AddQuotationForm = ({ isEdit, id, data }) => {
  const [menu, setMenu] = useState(false);

  const [sendingEmail, setSendingEmail] = useState(false);
  const { FetchInvoiceStatus } = useQuotationHook();
  const { status } = FetchInvoiceStatus();
  const invoice = window.INVOICE;
  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("w-100"));
  }, []);

  const getSeletedCustomer = (value) => {
    if (!value) return null;
    return {
      value: value.id,
      label: value?.user?.full_name,
      data: value,
    };
  };

  const leadStage = [
    { value: "new", label: "New" },
    { value: "technical", label: "Technical" },
    { value: "false_inquiry", label: "False inquiry" },
    { value: "follow_up", label: "Follow up" },
  ];
  const initialValues = isEdit
    ? {
        ...data,
        customer: getSeletedCustomer(data?.customer),
        lead_stage: leadStage.find((stage) => stage.value === data?.lead_stage)
      }
    : {};

  function transformInvoicePayload(data) {
    // Make sure to import moment at the top of your file:

    return {
      reference: data.reference || "",
      customer_id: data.customer?.value || null,
      subject: data.subject || "",
      quote_date: moment(data.quote_date).format("YYYY-MM-DD"),
      due_date: moment(data.due_date).format("YYYY-MM-DD"),
      expiry_date: moment(data.expiry_date).format("YYYY-MM-DD"),
      customer_notes: data.customer_notes || "",
      terms: data.terms || "",
      signature_name: data.signature_name || invoice?.digital_signature_name,
      signature_image: data.signature_image || invoice?.digital_signature_image,
      discount_value: data.discount_value || 0,
      load_source: data.load_source || "",
      lead_stage: data?.lead_stage?.value || "",
      tax: data.tax || 0,
      items: (data.items || []).map((item) => ({
        product: item.product || null,
        quantity: item.quantity || 0,
        unit: item.unit || "",
        rate: item.rate || 0,
        discount: item.discount || 0,
      })),
    };
  }

  const onSubmit = (values) => {
    if (!values?.items || values?.items?.length === 0) {
      alertify.error("Please add at least one product.");
      return;
    }
    // Check if all required fields have values for each product
    const hasEmptyFields = values.items.some(
      (item) => !item.product || !item.quantity || !item.unit || !item.rate
    );

    if (hasEmptyFields) {
      alertify.error("Please fill all required fields for each product.");
      return;
    }
    const transformedValues = transformInvoicePayload(values);
    fetch(isEdit ? `/invoice/quotes/${data?.id}/` : "/invoice/quotes/", {
      method: isEdit ? "PUT" : "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
      credentials: "include",
      body: JSON.stringify(transformedValues),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!isEdit && data?.data?.total_invoice_amount_in_words) {
          window.location.href = `/invoice/quotations`;
        } else if (data?.total_invoice_amount_in_words) {
          window.location.href = `/invoice/quotations`;
        }
        console.log("error:", data);
      })
      .catch((error) => {
        console.error("Error adding invoice:", error);
      });
  };
  const handleSendEmail = (e) => {
    setSendingEmail(true);
    e.preventDefault();
    fetch(`/invoice/quote/${data?.id}/send-email/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Email sent successfully:", data);
        setSendingEmail(false);
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        setSendingEmail(false);
      });
  };

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5> {isEdit ? "Edit Quote" : "Add Quote"}</h5>
                </div>
              </div>
              <Form
                onSubmit={onSubmit}
                initialValues={{
                  ...initialValues,
                  quote_date: initialValues?.quote_date
                    ? new Date(initialValues?.quote_date)
                    : new Date(),
                  expiry_date: initialValues?.expiry_date
                    ? new Date(initialValues?.expiry_date)
                    : new Date(),
                  signature_name:
                    initialValues.signature_name ||
                    invoice?.digital_signature_name,
                  signature_image:
                    initialValues.signature_image ||
                    invoice?.digital_signature_image,
                  terms:
                    initialValues.terms || invoice?.invoice_terms_conditions,
                  items: initialValues?.items || [],
                }}
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                  valid,
                }) => (
                  <form
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  >
                    <BasicInvoiceDetailsForm
                      status={status?.status_choices || []}
                    />
                    <hr />
                    <ProductDetails />
                    <div className="form-group-item border-0 p-0">
                      <div className="row">
                        <BankDetailsForm />
                        <FinalTotalForm from={"quote"} />
                      </div>
                    </div>
                    <div className="add-customer-btns text-end">
                      <button
                        type="button"
                        className="btn btn-primary cancel me-2"
                        onClick={() =>
                          (window.location.href = "/invoice/quotations/")
                        }
                        disabled={submitting || pristine}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel me-2"
                        onClick={form.submit}
                        disabled={submitting || sendingEmail || !valid}
                      >
                        Save
                      </button>
                      {isEdit && pristine && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={submitting || sendingEmail || !valid}
                          onClick={(e) => {
                            e.preventDefault();
                            handleSendEmail(e);
                          }}
                        >
                          Send to customer
                          {sendingEmail && (
                            <i className="fas fa-spinner fa-spin ms-2"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddQuotationForm;
